import { createSlice } from '@reduxjs/toolkit';

import type { RootState } from '../index';

interface AutoFlowState {
  /** Whether auto-select has already fired this session */
  autoSelectTriggered: boolean;
}

const initialState: AutoFlowState = {
  autoSelectTriggered: false,
};

const autoFlowSlice = createSlice({
  name: 'autoFlow',
  initialState,
  reducers: {
    setAutoSelectTriggered: (state) => {
      state.autoSelectTriggered = true;
    },
    resetAutoSelectTriggered: (state) => {
      state.autoSelectTriggered = false;
    },
  },
});

export const { setAutoSelectTriggered, resetAutoSelectTriggered } = autoFlowSlice.actions;

export default autoFlowSlice.reducer;

export const autoSelectTriggeredSelector = (state: RootState) => state.autoFlow.autoSelectTriggered;
